export class OrganizationTableauConfiguration {
  clientId: string | undefined;
  secretId: string | undefined;
  secretValue: string | undefined;
  siteName: string | undefined;
  url: string | undefined;
  userName: string | undefined;
  siteId: string | undefined;
  tableauCloud: boolean = false;
  defaultSite: boolean = false;
}